import { Text, View } from '@react-pdf/renderer';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { handleNSI18Next } from 'src/models/Language.model';
import { Session } from 'src/models/Session.model';

import { cls } from 'src/utils/reactPdfStyles';

interface IInfoSectionProps {
  session: Session;
}

const InfoSection: React.FC<IInfoSectionProps> = ({ session }) => {
  const { handleReportT } = handleNSI18Next();

  const {
    practiceSettings: { shouldShowGender },
  } = useRemoteBoundStore.getState();

  return (
    <View>
      <View style={cls('hr my-2')} />

      <View style={cls('d-flex hstack my-2')}>
        <View style={cls('w-25')}>
          <Text style={cls('text-muted p-0 border-0')}>
            {handleReportT('info.patientID')}
          </Text>
          <Text style={cls('lead p-0 border-0')}>{session.id || ''}</Text>
        </View>

        <View style={cls('w-30')}>
          <Text style={cls('text-muted p-0 border-0')}>
            {handleReportT('info.patientName')}
          </Text>
          <Text
            hyphenationCallback={(word) => [word]}
            style={cls('lead pe-2 border-0')}
          >
            {session.firstName} {session.lastName}
          </Text>
        </View>

        <View style={cls('w-20')}>
          <Text style={cls('text-muted p-0 border-0')}>
            {handleReportT('info.dob')}
          </Text>
          <Text style={cls('lead p-0 border-0')}>{session.dob || ''}</Text>
        </View>

        {session.template?.includes('cvd') && shouldShowGender && (
          <View style={cls('w-20')}>
            <Text style={cls('text-muted p-0 border-0')}>
              {handleReportT('info.sex')}
            </Text>

            <Text style={cls('lead p-0 border-0')}>
              {session.gender && handleReportT(`info.${session.gender}`)}
            </Text>
          </View>
        )}

        <View style={cls('w-20 ms-auto')}>
          <Text style={cls('text-muted p-0 border-0')}>
            {handleReportT('info.dateAndTime')}
          </Text>
          <Text style={cls('lead p-0 border-0')}>
            <Text>{session.date}</Text>{' '}
            <Text style={cls('text-muted')}>{session.time}</Text>
          </Text>
        </View>
      </View>

      <View style={cls('hr my-2')} />
    </View>
  );
};

export default InfoSection;
